class ReputonWidget {
  constructor() {
    this.reviewsData = null;
    this.loadDataFromDOM();
  }

  loadDataFromDOM() {
    const reviewsHolder = document.getElementById('js__reputonAmazonProductReviewsData');
    if (reviewsHolder) {
      this.reviewsData = JSON.parse(reviewsHolder.value);
    }
  }

  init() {
      window.reputonAmazonProductReviewsData = this.reviewsData;
      if(this.reviewsData.reviewsNumber === 0){
        document.querySelector('.js__reputon').style.display = 'none';
      }
  }
}

new ReputonWidget().init();